import { useState, useCallback } from 'react';
import styles from './TermsAcceptanceScreen.module.css';

type Props = {
  onAccept: () => Promise<void>;
  isSubmitting: boolean;
  termsUrl: string;
};

export function TermsAcceptanceScreen({ onAccept, isSubmitting, termsUrl }: Props) {
  const [error, setError] = useState(false);

  const handleAccept = useCallback(async () => {
    setError(false);
    try {
      await onAccept();
    } catch {
      setError(true);
    }
  }, [onAccept]);

  return (
    <div className={styles.screen}>
      <div className={styles.eyebrow}>Before you continue</div>

      <h1 className={styles.title}>Please review our terms</h1>

      <a
        href={termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        Read the Terms of Service →
      </a>

      {error && (
        <p className={styles.error}>Couldn't save — tap to try again.</p>
      )}

      <button
        type="button"
        className={styles.cta}
        onClick={handleAccept}
        disabled={isSubmitting}
        autoFocus
      >
        I agree to the Terms of Service
      </button>
    </div>
  );
}
